import { initFaro } from "./faro";
import { createRoot } from "react-dom/client";
import App from "./App";
import "./index.css";

initFaro();

// Suppress ResizeObserver loop warning - this is a benign browser warning
// that can be triggered by browser extensions or UI libraries
const resizeObserverErr = (e: ErrorEvent) => {
  if (e.message === 'ResizeObserver loop completed with undelivered notifications.' ||
      e.message === 'ResizeObserver loop limit exceeded') {
    e.stopImmediatePropagation();
    e.preventDefault();
    return false;
  }
  // Log all other errors to console for debugging
  console.error('[Runtime Error]', e.message, e.error);
};
window.addEventListener('error', resizeObserverErr);

// Also catch unhandled promise rejections
window.addEventListener('unhandledrejection', (e) => {
  console.error('[Unhandled Promise Rejection]', e.reason);
});

createRoot(document.getElementById("root")!).render(<App />);
